var canvas = '_1t0vmmd4';
var root = '_1t0vmmd1';
var thumb = '_1t0vmmd5';
var thumbBg = '_1t0vmmd7 _1q2ok2r5';
var thumbShadow = '_1t0vmmd6 _1q2ok2r6';
var variant = {inset:'_1t0vmmd2',flush:'_1t0vmmd3'};

export { canvas, root, thumb, thumbBg, thumbShadow, variant };
//# sourceMappingURL=color-area.css.js.map
